import { FC } from 'react'
import Image from 'next/image'
import { Link } from 'components/ui'
import cn from 'classnames'
import { emptyImagePlaceholder } from 'constants/image'
import { ROUTE_SELLER_INDEX } from 'routes/sellers'
import type { SellerInlineProps } from '.'
import s from './seller-inline.module.css'

const SellerInline: FC<SellerInlineProps> = ({ withImage = true, pre = '', className, ...props }) => {
  const { slug, name, avatar } = props

  return (
    <Link href={`${ROUTE_SELLER_INDEX}/${slug}`}>
      <div className={cn(s.root, className)}>
        {pre !== '' && <div className={s.pre}>{pre}</div>}
        {withImage && (
          <div className={s.avatar}>
            <Image
              src={(avatar && (avatar?.url as string)) || emptyImagePlaceholder}
              alt={name}
              width="24px"
              height="24px"
            />
          </div>
        )}
        <div className={s.name}>{name}</div>
      </div>
    </Link>
  )
}

export default SellerInline
